import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, FormTextField, FormNumberTextField, FormActions } from "sprint-common-web";

import { EditEpisodeFormInputs } from "./EditEpisodeFormInputs";
import { useEditEpisodeForm } from "./useEditEpisodeForm";

export interface EditEpisodeFormProps {
    selectedEpisodeId: string;
    selectedSeasonId: string;
    onCancel(): void;
    onSubmit(updatedEpisodeData: UpdatedEpisodeData): void;
}

export interface UpdatedEpisodeData {
    episodeId: string;
    title: string;
    number: number;
}

export const EditEpisodeForm: React.FunctionComponent<EditEpisodeFormProps> = (props: EditEpisodeFormProps) => {
    const { selectedEpisode, editEpisode, isNewEpisodeTitleUnique, isNewEpisodeNumberUnique } = useEditEpisodeForm();

    const { errors, control, formState, handleSubmit } = useForm<EditEpisodeFormInputs>({
        defaultValues: {
            title: selectedEpisode.title,
            number: selectedEpisode.number
        },
        criteriaMode: "all"
    });

    const handleEditEpisode = async (inputs: EditEpisodeFormInputs) => {
        const updatedEpisode = await editEpisode(inputs);

        props.onSubmit(updatedEpisode);
    };

    const handleCancelClick = () => {
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditEpisode)}>
            <FormFields>
                <FormTextField
                    label="Title"
                    name="title"
                    control={control}
                    errors={errors}
                    rules={{
                        required: "Please enter Episode Name",
                        validate: isNewEpisodeTitleUnique
                    }}
                />
                <FormNumberTextField
                    label="Episode Number"
                    name="number"
                    control={control}
                    errors={errors}
                    rules={{
                        required: "Please enter Episode Number",
                        pattern: {
                            value: /^\d+$/i,
                            message: "Please enter correct Episode Number"
                        },
                        validate: isNewEpisodeNumberUnique
                    }}
                />
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={handleCancelClick} />
        </Form>
    );
};
